import { AutoProduct } from 'src/enums/AutoProduct'

const QUERY_PRESERVE_PARAMS = [
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_medium',
  'utm_source',
  'category',
  'utm_adgroup',
  'utm_network',
  'utm_matchtype',
  'utm_device',
  'utm_placement',
  'utm_adposition',
  'utm_location',
  'utm_sitelink',
  'utm_audience',
  'utm_promotion',
  'utm_price',
  'source',
]

export const redirectUrlWithQuery = baseURL => {
  const url = new URL(baseURL)
  const urlParams = new URLSearchParams(window.location.search)
  QUERY_PRESERVE_PARAMS.forEach(item => {
    const value = urlParams.get(item)
    if (value && !url.searchParams.get(item)) {
      url.searchParams.append(item, value)
    }
  })
  return url.href
}

export const getModalType = (code, illogicalFlowData, product) => {
  switch (code) {
    case 'ILLOGICAL_FLOW_POLICY_EXISTS':
      if (illogicalFlowData?.is_user_blocked) {
        if (illogicalFlowData?.remaining_days < 60) {
          if (illogicalFlowData?.vehicle_type === 'car') {
            return 'USER_BLOCKED_POLICY_EXPIRING_CAR'
          }
          return 'USER_BLOCKED_POLICY_EXPIRING_BIKE'
        } else {
          if (illogicalFlowData?.vehicle_type === 'car') {
            return 'USER_BLOCKED_POLICY_ONGOING_CAR'
          }
          return 'USER_BLOCKED_POLICY_ONGOING_BIKE'
        }
      } else if (illogicalFlowData?.remaining_days < 60) {
        if (illogicalFlowData?.vehicle_type === 'car') return 'CAR_EXPIRING'
        else return 'BIKE_EXPIRING'
      } else if (illogicalFlowData?.vehicle_type !== 'bike') return 'ONGOING_POLICY_CAR'
      else return 'ONGOING_POLICY_BIKE'
    case 'ILLOGICAL_FLOW_PAYMENT_DONE':
      if (illogicalFlowData?.pi_scheduled) {
        if (product === AutoProduct.Car) return 'INSPECTION_DONE'
        return 'MISMATCH_INSPECTION_DONE'
      } else {
        if (product === AutoProduct.Car) return 'INSPECTION_PENDING'
        return 'MISMATCH_INSPECTION_PENDING'
      }
    case 'ILLOGICAL_FLOW_POLICY_EXPIRED_RENEWAL_DUE':
      if (illogicalFlowData?.is_user_blocked) {
        if (illogicalFlowData?.vehicle_type === 'car') {
          return 'USER_BLOCKED_POLICY_EXPIRED_CAR'
        }
        return 'USER_BLOCKED_POLICY_EXPIRED_BIKE'
      } else if (illogicalFlowData?.vehicle_type === 'car') return 'CAR_EXPIRED'
      else return 'BIKE_EXPIRED'

    case 'MODEL_UNSERVICEABLE':
      if (illogicalFlowData?.vehicle_type === 'car') return 'CAR_MODEL_UNSERVICEABLE'
      else return 'BIKE_MODEL_UNSERVICEABLE'
    default:
      return 'ONGOING_POLICY_CAR'
  }
}

export const getSegmentPayload = product => {
  try {
    return {
      path: window.location.href,
      journey: `buy fresh ${product}`,
      product: 'auto',
      platform: window.innerWidth > 768 ? 'web' : 'mweb',
      from_page: sessionStorage?.getItem('lastPage'),
    }
  } catch {
    return {}
  }
}

export const getReverseAutoProduct = (product: AutoProduct) => {
  if (product === AutoProduct.Bike) return AutoProduct.Car
  return AutoProduct.Bike
}
